import {
  notificationWebSocketEnvelopeSchema,
  type NotificationWebSocketEnvelope,
} from '@billing/validation';
import { subscribeToWebSocketMessages } from './session';

export const subscribeToNotificationEvents = (
  subscriber: (event: NotificationWebSocketEnvelope) => void
) =>
  subscribeToWebSocketMessages((event) => {
    if (typeof event.data !== 'string') return;
    try {
      const parsed = notificationWebSocketEnvelopeSchema.safeParse(
        JSON.parse(event.data)
      );
      if (parsed.success) subscriber(parsed.data);
    } catch {
      // Other WebSocket routes use different payloads; ignore them here.
    }
  });
